import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <h1 onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>EduStaff</h1>
          <button className="btn-back" onClick={() => navigate(-1)}>
            ← 뒤로가기
          </button>
        </div>
      </header>

      <main className="legal-content">
        <div className="legal-container">
          <h1 className="legal-title">개인정보처리방침</h1>
          <p className="legal-updated">최종 업데이트: 2024년 12월 24일</p>

          <section className="legal-section">
            <h2>제1조 (개인정보의 처리목적)</h2>
            <p>
              아이지에듀랩(이하 "회사")은 다음의 목적을 위하여 개인정보를 처리합니다.
              처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며,
              이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <ol>
              <li><strong>회원 가입 및 관리</strong>
                <p>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지·통지 목적으로 개인정보를 처리합니다.</p>
              </li>
              <li><strong>서비스 제공</strong>
                <p>학원 관리 서비스 제공, 콘텐츠 제공, 본인인증, 요금결제·정산을 목적으로 개인정보를 처리합니다.</p>
              </li>
              <li><strong>고충처리</strong>
                <p>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 목적으로 개인정보를 처리합니다.</p>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제2조 (처리하는 개인정보의 항목)</h2>
            <p>회사는 다음의 개인정보 항목을 처리하고 있습니다:</p>
            <ol>
              <li><strong>필수항목</strong>
                <ul>
                  <li>회원가입 시: 이메일, 비밀번호, 이름, 학원명, 연락처</li>
                  <li>학생 관리 시: 학생 이름, 학년, 반, 연락처, 학부모 정보</li>
                  <li>결제 시: 결제정보(카드번호, 계좌번호 등은 PG사에서 암호화하여 보관)</li>
                </ul>
              </li>
              <li><strong>자동 수집 항목</strong>
                <ul>
                  <li>서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제3조 (개인정보의 처리 및 보유기간)</h2>
            <ol>
              <li>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</li>
              <li>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다:
                <ul>
                  <li>회원정보: 회원 탈퇴 시까지 (단, 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지)</li>
                  <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)</li>
                  <li>대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)</li>
                  <li>소비자 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)</li>
                  <li>웹사이트 방문기록: 3개월 (통신비밀보호법)</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제4조 (개인정보의 제3자 제공)</h2>
            <p>
              회사는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며,
              정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>제5조 (개인정보처리의 위탁)</h2>
            <p>회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다:</p>
            <table className="privacy-table">
              <thead>
                <tr>
                  <th>위탁받는 자</th>
                  <th>위탁하는 업무의 내용</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>결제대행업체(PG사)</td>
                  <td>결제 처리 및 정산</td>
                </tr>
                <tr>
                  <td>SMS 발송 대행업체</td>
                  <td>알림톡 및 문자 발송</td>
                </tr>
              </tbody>
            </table>
            <p>
              회사는 위탁계약 체결 시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
              기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을
              계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>제6조 (정보주체의 권리·의무 및 행사방법)</h2>
            <ol>
              <li>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다:
                <ul>
                  <li>개인정보 열람 요구</li>
                  <li>오류 등이 있을 경우 정정 요구</li>
                  <li>삭제 요구</li>
                  <li>처리정지 요구</li>
                </ul>
              </li>
              <li>제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.</li>
              <li>정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제7조 (개인정보의 파기)</h2>
            <ol>
              <li>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</li>
              <li>정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</li>
              <li>개인정보 파기의 절차 및 방법은 다음과 같습니다:
                <ul>
                  <li><strong>파기절차:</strong> 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</li>
                  <li><strong>파기방법:</strong> 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제8조 (개인정보의 안전성 확보조치)</h2>
            <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다:</p>
            <ol>
              <li><strong>관리적 조치:</strong> 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
              <li><strong>기술적 조치:</strong> 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li>
              <li><strong>물리적 조치:</strong> 전산실, 자료보관실 등의 접근통제</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h2>
            <ol>
              <li>회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.</li>
              <li>쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.</li>
              <li>쿠키의 설치·운영 및 거부:
                <ul>
                  <li>웹브라우저 상단의 도구 → 인터넷 옵션 → 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다.</li>
                  <li>쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제10조 (개인정보 보호책임자)</h2>
            <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
            <div className="contact-box">
              <h3>▶ 개인정보 보호책임자</h3>
              <ul>
                <li>이름: 송인규</li>
                <li>직책: 대표</li>
                <li>이메일: acaeduno1@gmail.com</li>
              </ul>
            </div>
            <p>
              정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
              개인정보 보호책임자에게 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>제11조 (개인정보 열람청구)</h2>
            <p>
              정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다.
              회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
            </p>
            <div className="contact-box">
              <h3>▶ 개인정보 열람청구 접수·처리 부서</h3>
              <ul>
                <li>이메일: acaeduno1@gmail.com</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>제12조 (권익침해 구제방법)</h2>
            <p>정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다:</p>
            <div className="contact-box">
              <h3>▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)</h3>
              <ul>
                <li>소관업무: 개인정보 침해사실 신고, 상담 신청</li>
                <li>홈페이지: privacy.kisa.or.kr</li>
                <li>전화: (국번없이) 118</li>
              </ul>
            </div>
            <div className="contact-box">
              <h3>▶ 개인정보 분쟁조정위원회</h3>
              <ul>
                <li>소관업무: 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
                <li>홈페이지: www.kopico.go.kr</li>
                <li>전화: (국번없이) 1833-6972</li>
              </ul>
            </div>
            <div className="contact-box">
              <h3>▶ 대검찰청 사이버범죄수사단</h3>
              <ul>
                <li>전화: 02-3480-3573 (www.spo.go.kr)</li>
              </ul>
            </div>
            <div className="contact-box">
              <h3>▶ 경찰청 사이버안전국</h3>
              <ul>
                <li>전화: (국번없이) 182 (cyberbureau.police.go.kr)</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>제13조 (개인정보 처리방침 변경)</h2>
            <p>이 개인정보 처리방침은 2024년 12월 24일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
          </section>
        </div>
      </main>

      <footer className="legal-footer">
        <p>&copy; 2024 EduStaff. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Privacy;
